/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createSolutionEvent = /* GraphQL */ `mutation CreateSolutionEvent($input: CreateSolutionEventInput!) {
  createSolutionEvent(input: $input)
}
` as GeneratedMutation<
  APITypes.CreateSolutionEventMutationVariables,
  APITypes.CreateSolutionEventMutation
>;
export const shareResourcePermission = /* GraphQL */ `mutation ShareResourcePermission(
  $executionId: ID!
  $input: [ManageResourcePermissionInput]!
) {
  shareResourcePermission(executionId: $executionId, input: $input) {
    executionId
    status
    result
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ShareResourcePermissionMutationVariables,
  APITypes.ShareResourcePermissionMutation
>;
export const revokeResourcePermission = /* GraphQL */ `mutation RevokeResourcePermission(
  $executionId: ID!
  $input: [ManageResourcePermissionInput]!
) {
  revokeResourcePermission(executionId: $executionId, input: $input) {
    executionId
    status
    result
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RevokeResourcePermissionMutationVariables,
  APITypes.RevokeResourcePermissionMutation
>;
export const createChimeMeeting = /* GraphQL */ `mutation CreateChimeMeeting($name: String!, $role: AttendeeRole!) {
  createChimeMeeting(name: $name, role: $role) {
    meetingInfo
    attendeeInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChimeMeetingMutationVariables,
  APITypes.CreateChimeMeetingMutation
>;
export const joinChimeMeeting = /* GraphQL */ `mutation JoinChimeMeeting(
  $meetingId: String!
  $name: String!
  $role: AttendeeRole!
) {
  joinChimeMeeting(meetingId: $meetingId, name: $name, role: $role) {
    meetingInfo
    attendeeInfo
    __typename
  }
}
` as GeneratedMutation<
  APITypes.JoinChimeMeetingMutationVariables,
  APITypes.JoinChimeMeetingMutation
>;
export const endChimeMeeting = /* GraphQL */ `mutation EndChimeMeeting($meetingId: String!) {
  endChimeMeeting(meetingId: $meetingId)
}
` as GeneratedMutation<
  APITypes.EndChimeMeetingMutationVariables,
  APITypes.EndChimeMeetingMutation
>;
export const startChimeMeetingRecording = /* GraphQL */ `mutation StartChimeMeetingRecording(
  $meetingId: String!
  $attachmentParentResourceType: PermissionResourceType
  $attachmentParentId: String
) {
  startChimeMeetingRecording(
    meetingId: $meetingId
    attachmentParentResourceType: $attachmentParentResourceType
    attachmentParentId: $attachmentParentId
  )
}
` as GeneratedMutation<
  APITypes.StartChimeMeetingRecordingMutationVariables,
  APITypes.StartChimeMeetingRecordingMutation
>;
export const createAttachment = /* GraphQL */ `mutation CreateAttachment(
  $input: CreateAttachmentInput!
  $condition: ModelAttachmentConditionInput
) {
  createAttachment(input: $input, condition: $condition) {
    id
    type
    parentId
    parentType
    propertyId
    key
    localCreatedAtTime
    status
    imageSource
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttachmentMutationVariables,
  APITypes.CreateAttachmentMutation
>;
export const updateAttachment = /* GraphQL */ `mutation UpdateAttachment(
  $input: UpdateAttachmentInput!
  $condition: ModelAttachmentConditionInput
) {
  updateAttachment(input: $input, condition: $condition) {
    id
    type
    parentId
    parentType
    propertyId
    key
    localCreatedAtTime
    status
    imageSource
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAttachmentMutationVariables,
  APITypes.UpdateAttachmentMutation
>;
export const deleteAttachment = /* GraphQL */ `mutation DeleteAttachment(
  $input: DeleteAttachmentInput!
  $condition: ModelAttachmentConditionInput
) {
  deleteAttachment(input: $input, condition: $condition) {
    id
    type
    parentId
    parentType
    propertyId
    key
    localCreatedAtTime
    status
    imageSource
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttachmentMutationVariables,
  APITypes.DeleteAttachmentMutation
>;
export const createBiddingContact = /* GraphQL */ `mutation CreateBiddingContact(
  $input: CreateBiddingContactInput!
  $condition: ModelBiddingContactConditionInput
) {
  createBiddingContact(input: $input, condition: $condition) {
    id
    email
    ownerEntityId
    contactEntityId
    name
    privateDescription
    publicDescription
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBiddingContactMutationVariables,
  APITypes.CreateBiddingContactMutation
>;
export const updateBiddingContact = /* GraphQL */ `mutation UpdateBiddingContact(
  $input: UpdateBiddingContactInput!
  $condition: ModelBiddingContactConditionInput
) {
  updateBiddingContact(input: $input, condition: $condition) {
    id
    email
    ownerEntityId
    contactEntityId
    name
    privateDescription
    publicDescription
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBiddingContactMutationVariables,
  APITypes.UpdateBiddingContactMutation
>;
export const deleteBiddingContact = /* GraphQL */ `mutation DeleteBiddingContact(
  $input: DeleteBiddingContactInput!
  $condition: ModelBiddingContactConditionInput
) {
  deleteBiddingContact(input: $input, condition: $condition) {
    id
    email
    ownerEntityId
    contactEntityId
    name
    privateDescription
    publicDescription
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBiddingContactMutationVariables,
  APITypes.DeleteBiddingContactMutation
>;
export const createBidInvitation = /* GraphQL */ `mutation CreateBidInvitation(
  $input: CreateBidInvitationInput!
  $condition: ModelBidInvitationConditionInput
) {
  createBidInvitation(input: $input, condition: $condition) {
    id
    biddingContactId
    tenderId
    ownerEntityId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBidInvitationMutationVariables,
  APITypes.CreateBidInvitationMutation
>;
export const updateBidInvitation = /* GraphQL */ `mutation UpdateBidInvitation(
  $input: UpdateBidInvitationInput!
  $condition: ModelBidInvitationConditionInput
) {
  updateBidInvitation(input: $input, condition: $condition) {
    id
    biddingContactId
    tenderId
    ownerEntityId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBidInvitationMutationVariables,
  APITypes.UpdateBidInvitationMutation
>;
export const deleteBidInvitation = /* GraphQL */ `mutation DeleteBidInvitation(
  $input: DeleteBidInvitationInput!
  $condition: ModelBidInvitationConditionInput
) {
  deleteBidInvitation(input: $input, condition: $condition) {
    id
    biddingContactId
    tenderId
    ownerEntityId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBidInvitationMutationVariables,
  APITypes.DeleteBidInvitationMutation
>;
export const createBid = /* GraphQL */ `mutation CreateBid(
  $input: CreateBidInput!
  $condition: ModelBidConditionInput
) {
  createBid(input: $input, condition: $condition) {
    id
    tenderId
    latestMinorVersion
    latestAcceptedMinorVersion
    latestSubmittedMinorVersion
    status
    bidNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBidMutationVariables,
  APITypes.CreateBidMutation
>;
export const updateBid = /* GraphQL */ `mutation UpdateBid(
  $input: UpdateBidInput!
  $condition: ModelBidConditionInput
) {
  updateBid(input: $input, condition: $condition) {
    id
    tenderId
    latestMinorVersion
    latestAcceptedMinorVersion
    latestSubmittedMinorVersion
    status
    bidNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBidMutationVariables,
  APITypes.UpdateBidMutation
>;
export const deleteBid = /* GraphQL */ `mutation DeleteBid(
  $input: DeleteBidInput!
  $condition: ModelBidConditionInput
) {
  deleteBid(input: $input, condition: $condition) {
    id
    tenderId
    latestMinorVersion
    latestAcceptedMinorVersion
    latestSubmittedMinorVersion
    status
    bidNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBidMutationVariables,
  APITypes.DeleteBidMutation
>;
export const createBidMinorVersion = /* GraphQL */ `mutation CreateBidMinorVersion(
  $input: CreateBidMinorVersionInput!
  $condition: ModelBidMinorVersionConditionInput
) {
  createBidMinorVersion(input: $input, condition: $condition) {
    id
    bidId
    minorVersion
    tenderId
    tenderMinorVersion
    proposalId
    status
    metadata {
      bidderContactName
      bidderContactEmail
      bidderCompanyName
      bidderContactAddress
      bidderContactPhoneNumber
      bidderWebsite
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBidMinorVersionMutationVariables,
  APITypes.CreateBidMinorVersionMutation
>;
export const updateBidMinorVersion = /* GraphQL */ `mutation UpdateBidMinorVersion(
  $input: UpdateBidMinorVersionInput!
  $condition: ModelBidMinorVersionConditionInput
) {
  updateBidMinorVersion(input: $input, condition: $condition) {
    id
    bidId
    minorVersion
    tenderId
    tenderMinorVersion
    proposalId
    status
    metadata {
      bidderContactName
      bidderContactEmail
      bidderCompanyName
      bidderContactAddress
      bidderContactPhoneNumber
      bidderWebsite
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBidMinorVersionMutationVariables,
  APITypes.UpdateBidMinorVersionMutation
>;
export const deleteBidMinorVersion = /* GraphQL */ `mutation DeleteBidMinorVersion(
  $input: DeleteBidMinorVersionInput!
  $condition: ModelBidMinorVersionConditionInput
) {
  deleteBidMinorVersion(input: $input, condition: $condition) {
    id
    bidId
    minorVersion
    tenderId
    tenderMinorVersion
    proposalId
    status
    metadata {
      bidderContactName
      bidderContactEmail
      bidderCompanyName
      bidderContactAddress
      bidderContactPhoneNumber
      bidderWebsite
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBidMinorVersionMutationVariables,
  APITypes.DeleteBidMinorVersionMutation
>;
export const createClientLog = /* GraphQL */ `mutation CreateClientLog(
  $input: CreateClientLogInput!
  $condition: ModelClientLogConditionInput
) {
  createClientLog(input: $input, condition: $condition) {
    id
    userId
    userAgent
    severityLevel
    componentName
    message
    details
    tags
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateClientLogMutationVariables,
  APITypes.CreateClientLogMutation
>;
export const updateClientLog = /* GraphQL */ `mutation UpdateClientLog(
  $input: UpdateClientLogInput!
  $condition: ModelClientLogConditionInput
) {
  updateClientLog(input: $input, condition: $condition) {
    id
    userId
    userAgent
    severityLevel
    componentName
    message
    details
    tags
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateClientLogMutationVariables,
  APITypes.UpdateClientLogMutation
>;
export const deleteClientLog = /* GraphQL */ `mutation DeleteClientLog(
  $input: DeleteClientLogInput!
  $condition: ModelClientLogConditionInput
) {
  deleteClientLog(input: $input, condition: $condition) {
    id
    userId
    userAgent
    severityLevel
    componentName
    message
    details
    tags
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteClientLogMutationVariables,
  APITypes.DeleteClientLogMutation
>;
export const createCounter = /* GraphQL */ `mutation CreateCounter(
  $input: CreateCounterInput!
  $condition: ModelCounterConditionInput
) {
  createCounter(input: $input, condition: $condition) {
    id
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCounterMutationVariables,
  APITypes.CreateCounterMutation
>;
export const updateCounter = /* GraphQL */ `mutation UpdateCounter(
  $input: UpdateCounterInput!
  $condition: ModelCounterConditionInput
) {
  updateCounter(input: $input, condition: $condition) {
    id
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCounterMutationVariables,
  APITypes.UpdateCounterMutation
>;
export const deleteCounter = /* GraphQL */ `mutation DeleteCounter(
  $input: DeleteCounterInput!
  $condition: ModelCounterConditionInput
) {
  deleteCounter(input: $input, condition: $condition) {
    id
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCounterMutationVariables,
  APITypes.DeleteCounterMutation
>;
export const createDesignDocument = /* GraphQL */ `mutation CreateDesignDocument(
  $input: CreateDesignDocumentInput!
  $condition: ModelDesignDocumentConditionInput
) {
  createDesignDocument(input: $input, condition: $condition) {
    id
    designDocumentGroupId
    propertyId
    projectId
    name
    status
    lastEvaluatedValidityStatus
    uploadStatus
    documentKey
    lastWorkScopeSpecificationItemNumber
    version
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDesignDocumentMutationVariables,
  APITypes.CreateDesignDocumentMutation
>;
export const updateDesignDocument = /* GraphQL */ `mutation UpdateDesignDocument(
  $input: UpdateDesignDocumentInput!
  $condition: ModelDesignDocumentConditionInput
) {
  updateDesignDocument(input: $input, condition: $condition) {
    id
    designDocumentGroupId
    propertyId
    projectId
    name
    status
    lastEvaluatedValidityStatus
    uploadStatus
    documentKey
    lastWorkScopeSpecificationItemNumber
    version
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDesignDocumentMutationVariables,
  APITypes.UpdateDesignDocumentMutation
>;
export const deleteDesignDocument = /* GraphQL */ `mutation DeleteDesignDocument(
  $input: DeleteDesignDocumentInput!
  $condition: ModelDesignDocumentConditionInput
) {
  deleteDesignDocument(input: $input, condition: $condition) {
    id
    designDocumentGroupId
    propertyId
    projectId
    name
    status
    lastEvaluatedValidityStatus
    uploadStatus
    documentKey
    lastWorkScopeSpecificationItemNumber
    version
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDesignDocumentMutationVariables,
  APITypes.DeleteDesignDocumentMutation
>;
export const createDesignDocumentGroup = /* GraphQL */ `mutation CreateDesignDocumentGroup(
  $input: CreateDesignDocumentGroupInput!
  $condition: ModelDesignDocumentGroupConditionInput
) {
  createDesignDocumentGroup(input: $input, condition: $condition) {
    id
    projectId
    propertyId
    name
    latestDocumentVersion
    documentContentKey
    solutionGroupNumber
    isLocked
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDesignDocumentGroupMutationVariables,
  APITypes.CreateDesignDocumentGroupMutation
>;
export const updateDesignDocumentGroup = /* GraphQL */ `mutation UpdateDesignDocumentGroup(
  $input: UpdateDesignDocumentGroupInput!
  $condition: ModelDesignDocumentGroupConditionInput
) {
  updateDesignDocumentGroup(input: $input, condition: $condition) {
    id
    projectId
    propertyId
    name
    latestDocumentVersion
    documentContentKey
    solutionGroupNumber
    isLocked
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDesignDocumentGroupMutationVariables,
  APITypes.UpdateDesignDocumentGroupMutation
>;
export const deleteDesignDocumentGroup = /* GraphQL */ `mutation DeleteDesignDocumentGroup(
  $input: DeleteDesignDocumentGroupInput!
  $condition: ModelDesignDocumentGroupConditionInput
) {
  deleteDesignDocumentGroup(input: $input, condition: $condition) {
    id
    projectId
    propertyId
    name
    latestDocumentVersion
    documentContentKey
    solutionGroupNumber
    isLocked
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDesignDocumentGroupMutationVariables,
  APITypes.DeleteDesignDocumentGroupMutation
>;
export const createDimension = /* GraphQL */ `mutation CreateDimension(
  $input: CreateDimensionInput!
  $condition: ModelDimensionConditionInput
) {
  createDimension(input: $input, condition: $condition) {
    id
    parentId
    propertyId
    createdInSolution
    description
    length
    lengthUnit
    width
    widthUnit
    dimensionType
    measurementUnit
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDimensionMutationVariables,
  APITypes.CreateDimensionMutation
>;
export const updateDimension = /* GraphQL */ `mutation UpdateDimension(
  $input: UpdateDimensionInput!
  $condition: ModelDimensionConditionInput
) {
  updateDimension(input: $input, condition: $condition) {
    id
    parentId
    propertyId
    createdInSolution
    description
    length
    lengthUnit
    width
    widthUnit
    dimensionType
    measurementUnit
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDimensionMutationVariables,
  APITypes.UpdateDimensionMutation
>;
export const deleteDimension = /* GraphQL */ `mutation DeleteDimension(
  $input: DeleteDimensionInput!
  $condition: ModelDimensionConditionInput
) {
  deleteDimension(input: $input, condition: $condition) {
    id
    parentId
    propertyId
    createdInSolution
    description
    length
    lengthUnit
    width
    widthUnit
    dimensionType
    measurementUnit
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDimensionMutationVariables,
  APITypes.DeleteDimensionMutation
>;
export const createDiscoverableWorkTypes = /* GraphQL */ `mutation CreateDiscoverableWorkTypes(
  $input: CreateDiscoverableWorkTypesInput!
  $condition: ModelDiscoverableWorkTypesConditionInput
) {
  createDiscoverableWorkTypes(input: $input, condition: $condition) {
    id
    workTypeGroupId
    defaultVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDiscoverableWorkTypesMutationVariables,
  APITypes.CreateDiscoverableWorkTypesMutation
>;
export const updateDiscoverableWorkTypes = /* GraphQL */ `mutation UpdateDiscoverableWorkTypes(
  $input: UpdateDiscoverableWorkTypesInput!
  $condition: ModelDiscoverableWorkTypesConditionInput
) {
  updateDiscoverableWorkTypes(input: $input, condition: $condition) {
    id
    workTypeGroupId
    defaultVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDiscoverableWorkTypesMutationVariables,
  APITypes.UpdateDiscoverableWorkTypesMutation
>;
export const deleteDiscoverableWorkTypes = /* GraphQL */ `mutation DeleteDiscoverableWorkTypes(
  $input: DeleteDiscoverableWorkTypesInput!
  $condition: ModelDiscoverableWorkTypesConditionInput
) {
  deleteDiscoverableWorkTypes(input: $input, condition: $condition) {
    id
    workTypeGroupId
    defaultVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDiscoverableWorkTypesMutationVariables,
  APITypes.DeleteDiscoverableWorkTypesMutation
>;
export const createEntityResourcePermission = /* GraphQL */ `mutation CreateEntityResourcePermission(
  $input: CreateEntityResourcePermissionInput!
  $condition: ModelEntityResourcePermissionConditionInput
) {
  createEntityResourcePermission(input: $input, condition: $condition) {
    id
    propertyId
    entityId
    entityType
    resourceId
    resourceType
    permissionType
    isGranted
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEntityResourcePermissionMutationVariables,
  APITypes.CreateEntityResourcePermissionMutation
>;
export const updateEntityResourcePermission = /* GraphQL */ `mutation UpdateEntityResourcePermission(
  $input: UpdateEntityResourcePermissionInput!
  $condition: ModelEntityResourcePermissionConditionInput
) {
  updateEntityResourcePermission(input: $input, condition: $condition) {
    id
    propertyId
    entityId
    entityType
    resourceId
    resourceType
    permissionType
    isGranted
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEntityResourcePermissionMutationVariables,
  APITypes.UpdateEntityResourcePermissionMutation
>;
export const deleteEntityResourcePermission = /* GraphQL */ `mutation DeleteEntityResourcePermission(
  $input: DeleteEntityResourcePermissionInput!
  $condition: ModelEntityResourcePermissionConditionInput
) {
  deleteEntityResourcePermission(input: $input, condition: $condition) {
    id
    propertyId
    entityId
    entityType
    resourceId
    resourceType
    permissionType
    isGranted
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEntityResourcePermissionMutationVariables,
  APITypes.DeleteEntityResourcePermissionMutation
>;
export const createEntityWorkTypeAssociation = /* GraphQL */ `mutation CreateEntityWorkTypeAssociation(
  $input: CreateEntityWorkTypeAssociationInput!
  $condition: ModelEntityWorkTypeAssociationConditionInput
) {
  createEntityWorkTypeAssociation(input: $input, condition: $condition) {
    id
    entityId
    entityType
    workTypeGroupId
    workTypeVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateEntityWorkTypeAssociationMutationVariables,
  APITypes.CreateEntityWorkTypeAssociationMutation
>;
export const updateEntityWorkTypeAssociation = /* GraphQL */ `mutation UpdateEntityWorkTypeAssociation(
  $input: UpdateEntityWorkTypeAssociationInput!
  $condition: ModelEntityWorkTypeAssociationConditionInput
) {
  updateEntityWorkTypeAssociation(input: $input, condition: $condition) {
    id
    entityId
    entityType
    workTypeGroupId
    workTypeVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateEntityWorkTypeAssociationMutationVariables,
  APITypes.UpdateEntityWorkTypeAssociationMutation
>;
export const deleteEntityWorkTypeAssociation = /* GraphQL */ `mutation DeleteEntityWorkTypeAssociation(
  $input: DeleteEntityWorkTypeAssociationInput!
  $condition: ModelEntityWorkTypeAssociationConditionInput
) {
  deleteEntityWorkTypeAssociation(input: $input, condition: $condition) {
    id
    entityId
    entityType
    workTypeGroupId
    workTypeVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteEntityWorkTypeAssociationMutationVariables,
  APITypes.DeleteEntityWorkTypeAssociationMutation
>;
export const createInspection = /* GraphQL */ `mutation CreateInspection(
  $input: CreateInspectionInput!
  $condition: ModelInspectionConditionInput
) {
  createInspection(input: $input, condition: $condition) {
    id
    propertyId
    createdByOrganizationId
    createdByUserId
    startTime
    endTime
    status
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInspectionMutationVariables,
  APITypes.CreateInspectionMutation
>;
export const updateInspection = /* GraphQL */ `mutation UpdateInspection(
  $input: UpdateInspectionInput!
  $condition: ModelInspectionConditionInput
) {
  updateInspection(input: $input, condition: $condition) {
    id
    propertyId
    createdByOrganizationId
    createdByUserId
    startTime
    endTime
    status
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInspectionMutationVariables,
  APITypes.UpdateInspectionMutation
>;
export const deleteInspection = /* GraphQL */ `mutation DeleteInspection(
  $input: DeleteInspectionInput!
  $condition: ModelInspectionConditionInput
) {
  deleteInspection(input: $input, condition: $condition) {
    id
    propertyId
    createdByOrganizationId
    createdByUserId
    startTime
    endTime
    status
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInspectionMutationVariables,
  APITypes.DeleteInspectionMutation
>;
export const createIssue = /* GraphQL */ `mutation CreateIssue(
  $input: CreateIssueInput!
  $condition: ModelIssueConditionInput
) {
  createIssue(input: $input, condition: $condition) {
    id
    locationId
    propertyId
    inspectionId
    createdInSolution
    name
    description
    note
    tags
    tagIds
    status
    clientCreationDate
    localLastUpdatedTime
    createdBy
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    canViewList
    canViewEntityVersionMap
    isPubliclySubmitted
    suggestedWorkTypeIds
    quickQuoteIds
    proposalDocLinks {
      name
      link
      date
      __typename
    }
    priority
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateIssueMutationVariables,
  APITypes.CreateIssueMutation
>;
export const updateIssue = /* GraphQL */ `mutation UpdateIssue(
  $input: UpdateIssueInput!
  $condition: ModelIssueConditionInput
) {
  updateIssue(input: $input, condition: $condition) {
    id
    locationId
    propertyId
    inspectionId
    createdInSolution
    name
    description
    note
    tags
    tagIds
    status
    clientCreationDate
    localLastUpdatedTime
    createdBy
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    canViewList
    canViewEntityVersionMap
    isPubliclySubmitted
    suggestedWorkTypeIds
    quickQuoteIds
    proposalDocLinks {
      name
      link
      date
      __typename
    }
    priority
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIssueMutationVariables,
  APITypes.UpdateIssueMutation
>;
export const deleteIssue = /* GraphQL */ `mutation DeleteIssue(
  $input: DeleteIssueInput!
  $condition: ModelIssueConditionInput
) {
  deleteIssue(input: $input, condition: $condition) {
    id
    locationId
    propertyId
    inspectionId
    createdInSolution
    name
    description
    note
    tags
    tagIds
    status
    clientCreationDate
    localLastUpdatedTime
    createdBy
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    canViewList
    canViewEntityVersionMap
    isPubliclySubmitted
    suggestedWorkTypeIds
    quickQuoteIds
    proposalDocLinks {
      name
      link
      date
      __typename
    }
    priority
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteIssueMutationVariables,
  APITypes.DeleteIssueMutation
>;
export const createQuickQuote = /* GraphQL */ `mutation CreateQuickQuote(
  $input: CreateQuickQuoteInput!
  $condition: ModelQuickQuoteConditionInput
) {
  createQuickQuote(input: $input, condition: $condition) {
    id
    propertyId
    generatedProposalId
    status
    generatedSolutionId
    issueIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQuickQuoteMutationVariables,
  APITypes.CreateQuickQuoteMutation
>;
export const updateQuickQuote = /* GraphQL */ `mutation UpdateQuickQuote(
  $input: UpdateQuickQuoteInput!
  $condition: ModelQuickQuoteConditionInput
) {
  updateQuickQuote(input: $input, condition: $condition) {
    id
    propertyId
    generatedProposalId
    status
    generatedSolutionId
    issueIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateQuickQuoteMutationVariables,
  APITypes.UpdateQuickQuoteMutation
>;
export const deleteQuickQuote = /* GraphQL */ `mutation DeleteQuickQuote(
  $input: DeleteQuickQuoteInput!
  $condition: ModelQuickQuoteConditionInput
) {
  deleteQuickQuote(input: $input, condition: $condition) {
    id
    propertyId
    generatedProposalId
    status
    generatedSolutionId
    issueIds
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteQuickQuoteMutationVariables,
  APITypes.DeleteQuickQuoteMutation
>;
export const createLocation = /* GraphQL */ `mutation CreateLocation(
  $input: CreateLocationInput!
  $condition: ModelLocationConditionInput
) {
  createLocation(input: $input, condition: $condition) {
    id
    propertyId
    createdInSolution
    name
    tags
    localCreationTime
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLocationMutationVariables,
  APITypes.CreateLocationMutation
>;
export const updateLocation = /* GraphQL */ `mutation UpdateLocation(
  $input: UpdateLocationInput!
  $condition: ModelLocationConditionInput
) {
  updateLocation(input: $input, condition: $condition) {
    id
    propertyId
    createdInSolution
    name
    tags
    localCreationTime
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLocationMutationVariables,
  APITypes.UpdateLocationMutation
>;
export const deleteLocation = /* GraphQL */ `mutation DeleteLocation(
  $input: DeleteLocationInput!
  $condition: ModelLocationConditionInput
) {
  deleteLocation(input: $input, condition: $condition) {
    id
    propertyId
    createdInSolution
    name
    tags
    localCreationTime
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLocationMutationVariables,
  APITypes.DeleteLocationMutation
>;
export const createNote = /* GraphQL */ `mutation CreateNote(
  $input: CreateNoteInput!
  $condition: ModelNoteConditionInput
) {
  createNote(input: $input, condition: $condition) {
    id
    parentId
    propertyId
    note
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNoteMutationVariables,
  APITypes.CreateNoteMutation
>;
export const updateNote = /* GraphQL */ `mutation UpdateNote(
  $input: UpdateNoteInput!
  $condition: ModelNoteConditionInput
) {
  updateNote(input: $input, condition: $condition) {
    id
    parentId
    propertyId
    note
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNoteMutationVariables,
  APITypes.UpdateNoteMutation
>;
export const deleteNote = /* GraphQL */ `mutation DeleteNote(
  $input: DeleteNoteInput!
  $condition: ModelNoteConditionInput
) {
  deleteNote(input: $input, condition: $condition) {
    id
    parentId
    propertyId
    note
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNoteMutationVariables,
  APITypes.DeleteNoteMutation
>;
export const createOrganization = /* GraphQL */ `mutation CreateOrganization(
  $input: CreateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  createOrganization(input: $input, condition: $condition) {
    id
    legalName
    type
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationMutationVariables,
  APITypes.CreateOrganizationMutation
>;
export const updateOrganization = /* GraphQL */ `mutation UpdateOrganization(
  $input: UpdateOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  updateOrganization(input: $input, condition: $condition) {
    id
    legalName
    type
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationMutationVariables,
  APITypes.UpdateOrganizationMutation
>;
export const deleteOrganization = /* GraphQL */ `mutation DeleteOrganization(
  $input: DeleteOrganizationInput!
  $condition: ModelOrganizationConditionInput
) {
  deleteOrganization(input: $input, condition: $condition) {
    id
    legalName
    type
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrganizationMutationVariables,
  APITypes.DeleteOrganizationMutation
>;
export const createOrganizationBillingProfile = /* GraphQL */ `mutation CreateOrganizationBillingProfile(
  $input: CreateOrganizationBillingProfileInput!
  $condition: ModelOrganizationBillingProfileConditionInput
) {
  createOrganizationBillingProfile(input: $input, condition: $condition) {
    organizationId
    billingProfileId
    billingProvider
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrganizationBillingProfileMutationVariables,
  APITypes.CreateOrganizationBillingProfileMutation
>;
export const updateOrganizationBillingProfile = /* GraphQL */ `mutation UpdateOrganizationBillingProfile(
  $input: UpdateOrganizationBillingProfileInput!
  $condition: ModelOrganizationBillingProfileConditionInput
) {
  updateOrganizationBillingProfile(input: $input, condition: $condition) {
    organizationId
    billingProfileId
    billingProvider
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrganizationBillingProfileMutationVariables,
  APITypes.UpdateOrganizationBillingProfileMutation
>;
export const deleteOrganizationBillingProfile = /* GraphQL */ `mutation DeleteOrganizationBillingProfile(
  $input: DeleteOrganizationBillingProfileInput!
  $condition: ModelOrganizationBillingProfileConditionInput
) {
  deleteOrganizationBillingProfile(input: $input, condition: $condition) {
    organizationId
    billingProfileId
    billingProvider
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrganizationBillingProfileMutationVariables,
  APITypes.DeleteOrganizationBillingProfileMutation
>;
export const createTeam = /* GraphQL */ `mutation CreateTeam(
  $input: CreateTeamInput!
  $condition: ModelTeamConditionInput
) {
  createTeam(input: $input, condition: $condition) {
    id
    organizationId
    type
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTeamMutationVariables,
  APITypes.CreateTeamMutation
>;
export const updateTeam = /* GraphQL */ `mutation UpdateTeam(
  $input: UpdateTeamInput!
  $condition: ModelTeamConditionInput
) {
  updateTeam(input: $input, condition: $condition) {
    id
    organizationId
    type
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamMutationVariables,
  APITypes.UpdateTeamMutation
>;
export const deleteTeam = /* GraphQL */ `mutation DeleteTeam(
  $input: DeleteTeamInput!
  $condition: ModelTeamConditionInput
) {
  deleteTeam(input: $input, condition: $condition) {
    id
    organizationId
    type
    name
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTeamMutationVariables,
  APITypes.DeleteTeamMutation
>;
export const createTeamMember = /* GraphQL */ `mutation CreateTeamMember(
  $input: CreateTeamMemberInput!
  $condition: ModelTeamMemberConditionInput
) {
  createTeamMember(input: $input, condition: $condition) {
    id
    teamId
    organizationId
    userId
    joinedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTeamMemberMutationVariables,
  APITypes.CreateTeamMemberMutation
>;
export const updateTeamMember = /* GraphQL */ `mutation UpdateTeamMember(
  $input: UpdateTeamMemberInput!
  $condition: ModelTeamMemberConditionInput
) {
  updateTeamMember(input: $input, condition: $condition) {
    id
    teamId
    organizationId
    userId
    joinedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamMemberMutationVariables,
  APITypes.UpdateTeamMemberMutation
>;
export const deleteTeamMember = /* GraphQL */ `mutation DeleteTeamMember(
  $input: DeleteTeamMemberInput!
  $condition: ModelTeamMemberConditionInput
) {
  deleteTeamMember(input: $input, condition: $condition) {
    id
    teamId
    organizationId
    userId
    joinedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTeamMemberMutationVariables,
  APITypes.DeleteTeamMemberMutation
>;
export const createAccountInvitation = /* GraphQL */ `mutation CreateAccountInvitation(
  $input: CreateAccountInvitationInput!
  $condition: ModelAccountInvitationConditionInput
) {
  createAccountInvitation(input: $input, condition: $condition) {
    id
    organizationId
    role
    email
    expiresAt
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAccountInvitationMutationVariables,
  APITypes.CreateAccountInvitationMutation
>;
export const updateAccountInvitation = /* GraphQL */ `mutation UpdateAccountInvitation(
  $input: UpdateAccountInvitationInput!
  $condition: ModelAccountInvitationConditionInput
) {
  updateAccountInvitation(input: $input, condition: $condition) {
    id
    organizationId
    role
    email
    expiresAt
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAccountInvitationMutationVariables,
  APITypes.UpdateAccountInvitationMutation
>;
export const deleteAccountInvitation = /* GraphQL */ `mutation DeleteAccountInvitation(
  $input: DeleteAccountInvitationInput!
  $condition: ModelAccountInvitationConditionInput
) {
  deleteAccountInvitation(input: $input, condition: $condition) {
    id
    organizationId
    role
    email
    expiresAt
    status
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAccountInvitationMutationVariables,
  APITypes.DeleteAccountInvitationMutation
>;
export const createProject = /* GraphQL */ `mutation CreateProject(
  $input: CreateProjectInput!
  $condition: ModelProjectConditionInput
) {
  createProject(input: $input, condition: $condition) {
    id
    propertyId
    name
    tenderNumber
    customer
    address
    propertyType
    dueDate
    contactName
    contactNumber
    contactEmail
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectMutationVariables,
  APITypes.CreateProjectMutation
>;
export const updateProject = /* GraphQL */ `mutation UpdateProject(
  $input: UpdateProjectInput!
  $condition: ModelProjectConditionInput
) {
  updateProject(input: $input, condition: $condition) {
    id
    propertyId
    name
    tenderNumber
    customer
    address
    propertyType
    dueDate
    contactName
    contactNumber
    contactEmail
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectMutationVariables,
  APITypes.UpdateProjectMutation
>;
export const deleteProject = /* GraphQL */ `mutation DeleteProject(
  $input: DeleteProjectInput!
  $condition: ModelProjectConditionInput
) {
  deleteProject(input: $input, condition: $condition) {
    id
    propertyId
    name
    tenderNumber
    customer
    address
    propertyType
    dueDate
    contactName
    contactNumber
    contactEmail
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectMutationVariables,
  APITypes.DeleteProjectMutation
>;
export const createProjectCounter = /* GraphQL */ `mutation CreateProjectCounter(
  $input: CreateProjectCounterInput!
  $condition: ModelProjectCounterConditionInput
) {
  createProjectCounter(input: $input, condition: $condition) {
    id
    propertyId
    latestProjectNumber
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectCounterMutationVariables,
  APITypes.CreateProjectCounterMutation
>;
export const updateProjectCounter = /* GraphQL */ `mutation UpdateProjectCounter(
  $input: UpdateProjectCounterInput!
  $condition: ModelProjectCounterConditionInput
) {
  updateProjectCounter(input: $input, condition: $condition) {
    id
    propertyId
    latestProjectNumber
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectCounterMutationVariables,
  APITypes.UpdateProjectCounterMutation
>;
export const deleteProjectCounter = /* GraphQL */ `mutation DeleteProjectCounter(
  $input: DeleteProjectCounterInput!
  $condition: ModelProjectCounterConditionInput
) {
  deleteProjectCounter(input: $input, condition: $condition) {
    id
    propertyId
    latestProjectNumber
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectCounterMutationVariables,
  APITypes.DeleteProjectCounterMutation
>;
export const createProperty = /* GraphQL */ `mutation CreateProperty(
  $input: CreatePropertyInput!
  $condition: ModelPropertyConditionInput
) {
  createProperty(input: $input, condition: $condition) {
    id
    name
    description
    address
    ownerOrganizationId
    primaryContactNumber
    primaryContactEmail
    primaryContactName
    propertyNumber
    locations {
      items {
        id
        propertyId
        createdInSolution
        name
        tags
        localCreationTime
        localLastUpdatedTime
        opaqueSyncReconciliationToken
        canView
        canEdit
        canDelete
        createdBy
        canViewList
        canViewEntityVersionMap
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdBy
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    autoDashboardRebuild
    canView
    canEdit
    canCreateSolutions
    canDelete
    canViewList
    canViewEntityVersionMap
    isTestProperty
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePropertyMutationVariables,
  APITypes.CreatePropertyMutation
>;
export const updateProperty = /* GraphQL */ `mutation UpdateProperty(
  $input: UpdatePropertyInput!
  $condition: ModelPropertyConditionInput
) {
  updateProperty(input: $input, condition: $condition) {
    id
    name
    description
    address
    ownerOrganizationId
    primaryContactNumber
    primaryContactEmail
    primaryContactName
    propertyNumber
    locations {
      items {
        id
        propertyId
        createdInSolution
        name
        tags
        localCreationTime
        localLastUpdatedTime
        opaqueSyncReconciliationToken
        canView
        canEdit
        canDelete
        createdBy
        canViewList
        canViewEntityVersionMap
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdBy
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    autoDashboardRebuild
    canView
    canEdit
    canCreateSolutions
    canDelete
    canViewList
    canViewEntityVersionMap
    isTestProperty
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePropertyMutationVariables,
  APITypes.UpdatePropertyMutation
>;
export const deleteProperty = /* GraphQL */ `mutation DeleteProperty(
  $input: DeletePropertyInput!
  $condition: ModelPropertyConditionInput
) {
  deleteProperty(input: $input, condition: $condition) {
    id
    name
    description
    address
    ownerOrganizationId
    primaryContactNumber
    primaryContactEmail
    primaryContactName
    propertyNumber
    locations {
      items {
        id
        propertyId
        createdInSolution
        name
        tags
        localCreationTime
        localLastUpdatedTime
        opaqueSyncReconciliationToken
        canView
        canEdit
        canDelete
        createdBy
        canViewList
        canViewEntityVersionMap
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdBy
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    autoDashboardRebuild
    canView
    canEdit
    canCreateSolutions
    canDelete
    canViewList
    canViewEntityVersionMap
    isTestProperty
    isArchived
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePropertyMutationVariables,
  APITypes.DeletePropertyMutation
>;
export const createPropertyCounter = /* GraphQL */ `mutation CreatePropertyCounter(
  $input: CreatePropertyCounterInput!
  $condition: ModelPropertyCounterConditionInput
) {
  createPropertyCounter(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePropertyCounterMutationVariables,
  APITypes.CreatePropertyCounterMutation
>;
export const updatePropertyCounter = /* GraphQL */ `mutation UpdatePropertyCounter(
  $input: UpdatePropertyCounterInput!
  $condition: ModelPropertyCounterConditionInput
) {
  updatePropertyCounter(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePropertyCounterMutationVariables,
  APITypes.UpdatePropertyCounterMutation
>;
export const deletePropertyCounter = /* GraphQL */ `mutation DeletePropertyCounter(
  $input: DeletePropertyCounterInput!
  $condition: ModelPropertyCounterConditionInput
) {
  deletePropertyCounter(input: $input, condition: $condition) {
    id
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePropertyCounterMutationVariables,
  APITypes.DeletePropertyCounterMutation
>;
export const createProposal = /* GraphQL */ `mutation CreateProposal(
  $input: CreateProposalInput!
  $condition: ModelProposalConditionInput
) {
  createProposal(input: $input, condition: $condition) {
    id
    schemaVersion
    designDocumentGroupId
    designDocumentVersion
    proposalKey
    proposalNumber
    status
    author
    createdAt
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    quickQuoteId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProposalMutationVariables,
  APITypes.CreateProposalMutation
>;
export const updateProposal = /* GraphQL */ `mutation UpdateProposal(
  $input: UpdateProposalInput!
  $condition: ModelProposalConditionInput
) {
  updateProposal(input: $input, condition: $condition) {
    id
    schemaVersion
    designDocumentGroupId
    designDocumentVersion
    proposalKey
    proposalNumber
    status
    author
    createdAt
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    quickQuoteId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProposalMutationVariables,
  APITypes.UpdateProposalMutation
>;
export const deleteProposal = /* GraphQL */ `mutation DeleteProposal(
  $input: DeleteProposalInput!
  $condition: ModelProposalConditionInput
) {
  deleteProposal(input: $input, condition: $condition) {
    id
    schemaVersion
    designDocumentGroupId
    designDocumentVersion
    proposalKey
    proposalNumber
    status
    author
    createdAt
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    quickQuoteId
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProposalMutationVariables,
  APITypes.DeleteProposalMutation
>;
export const createProposalCounter = /* GraphQL */ `mutation CreateProposalCounter(
  $input: CreateProposalCounterInput!
  $condition: ModelProposalCounterConditionInput
) {
  createProposalCounter(input: $input, condition: $condition) {
    id
    solutionGroupId
    solutionVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProposalCounterMutationVariables,
  APITypes.CreateProposalCounterMutation
>;
export const updateProposalCounter = /* GraphQL */ `mutation UpdateProposalCounter(
  $input: UpdateProposalCounterInput!
  $condition: ModelProposalCounterConditionInput
) {
  updateProposalCounter(input: $input, condition: $condition) {
    id
    solutionGroupId
    solutionVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProposalCounterMutationVariables,
  APITypes.UpdateProposalCounterMutation
>;
export const deleteProposalCounter = /* GraphQL */ `mutation DeleteProposalCounter(
  $input: DeleteProposalCounterInput!
  $condition: ModelProposalCounterConditionInput
) {
  deleteProposalCounter(input: $input, condition: $condition) {
    id
    solutionGroupId
    solutionVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProposalCounterMutationVariables,
  APITypes.DeleteProposalCounterMutation
>;
export const createResourceUserPermissions = /* GraphQL */ `mutation CreateResourceUserPermissions(
  $input: CreateResourceUserPermissionsInput!
  $condition: ModelResourceUserPermissionsConditionInput
) {
  createResourceUserPermissions(input: $input, condition: $condition) {
    id
    resourceId
    userId
    userEmail
    userFullName
    resourceAndUserId
    permissions
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResourceUserPermissionsMutationVariables,
  APITypes.CreateResourceUserPermissionsMutation
>;
export const updateResourceUserPermissions = /* GraphQL */ `mutation UpdateResourceUserPermissions(
  $input: UpdateResourceUserPermissionsInput!
  $condition: ModelResourceUserPermissionsConditionInput
) {
  updateResourceUserPermissions(input: $input, condition: $condition) {
    id
    resourceId
    userId
    userEmail
    userFullName
    resourceAndUserId
    permissions
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateResourceUserPermissionsMutationVariables,
  APITypes.UpdateResourceUserPermissionsMutation
>;
export const deleteResourceUserPermissions = /* GraphQL */ `mutation DeleteResourceUserPermissions(
  $input: DeleteResourceUserPermissionsInput!
  $condition: ModelResourceUserPermissionsConditionInput
) {
  deleteResourceUserPermissions(input: $input, condition: $condition) {
    id
    resourceId
    userId
    userEmail
    userFullName
    resourceAndUserId
    permissions
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteResourceUserPermissionsMutationVariables,
  APITypes.DeleteResourceUserPermissionsMutation
>;
export const createSolution = /* GraphQL */ `mutation CreateSolution(
  $input: CreateSolutionInput!
  $condition: ModelSolutionConditionInput
) {
  createSolution(input: $input, condition: $condition) {
    id
    propertyId
    projectId
    name
    status
    latestMinorVersion
    latestContentKey
    serialNumber
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      tenderingType
      warranty
      __typename
    }
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSolutionMutationVariables,
  APITypes.CreateSolutionMutation
>;
export const updateSolution = /* GraphQL */ `mutation UpdateSolution(
  $input: UpdateSolutionInput!
  $condition: ModelSolutionConditionInput
) {
  updateSolution(input: $input, condition: $condition) {
    id
    propertyId
    projectId
    name
    status
    latestMinorVersion
    latestContentKey
    serialNumber
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      tenderingType
      warranty
      __typename
    }
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSolutionMutationVariables,
  APITypes.UpdateSolutionMutation
>;
export const deleteSolution = /* GraphQL */ `mutation DeleteSolution(
  $input: DeleteSolutionInput!
  $condition: ModelSolutionConditionInput
) {
  deleteSolution(input: $input, condition: $condition) {
    id
    propertyId
    projectId
    name
    status
    latestMinorVersion
    latestContentKey
    serialNumber
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      tenderingType
      warranty
      __typename
    }
    localLastUpdatedTime
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSolutionMutationVariables,
  APITypes.DeleteSolutionMutation
>;
export const createSolutionMinorVersion = /* GraphQL */ `mutation CreateSolutionMinorVersion(
  $input: CreateSolutionMinorVersionInput!
  $condition: ModelSolutionMinorVersionConditionInput
) {
  createSolutionMinorVersion(input: $input, condition: $condition) {
    id
    solutionId
    propertyId
    name
    contentKey
    minorVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSolutionMinorVersionMutationVariables,
  APITypes.CreateSolutionMinorVersionMutation
>;
export const updateSolutionMinorVersion = /* GraphQL */ `mutation UpdateSolutionMinorVersion(
  $input: UpdateSolutionMinorVersionInput!
  $condition: ModelSolutionMinorVersionConditionInput
) {
  updateSolutionMinorVersion(input: $input, condition: $condition) {
    id
    solutionId
    propertyId
    name
    contentKey
    minorVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSolutionMinorVersionMutationVariables,
  APITypes.UpdateSolutionMinorVersionMutation
>;
export const deleteSolutionMinorVersion = /* GraphQL */ `mutation DeleteSolutionMinorVersion(
  $input: DeleteSolutionMinorVersionInput!
  $condition: ModelSolutionMinorVersionConditionInput
) {
  deleteSolutionMinorVersion(input: $input, condition: $condition) {
    id
    solutionId
    propertyId
    name
    contentKey
    minorVersion
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSolutionMinorVersionMutationVariables,
  APITypes.DeleteSolutionMinorVersionMutation
>;
export const createSolutionGroupCounter = /* GraphQL */ `mutation CreateSolutionGroupCounter(
  $input: CreateSolutionGroupCounterInput!
  $condition: ModelSolutionGroupCounterConditionInput
) {
  createSolutionGroupCounter(input: $input, condition: $condition) {
    id
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSolutionGroupCounterMutationVariables,
  APITypes.CreateSolutionGroupCounterMutation
>;
export const updateSolutionGroupCounter = /* GraphQL */ `mutation UpdateSolutionGroupCounter(
  $input: UpdateSolutionGroupCounterInput!
  $condition: ModelSolutionGroupCounterConditionInput
) {
  updateSolutionGroupCounter(input: $input, condition: $condition) {
    id
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSolutionGroupCounterMutationVariables,
  APITypes.UpdateSolutionGroupCounterMutation
>;
export const deleteSolutionGroupCounter = /* GraphQL */ `mutation DeleteSolutionGroupCounter(
  $input: DeleteSolutionGroupCounterInput!
  $condition: ModelSolutionGroupCounterConditionInput
) {
  deleteSolutionGroupCounter(input: $input, condition: $condition) {
    id
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSolutionGroupCounterMutationVariables,
  APITypes.DeleteSolutionGroupCounterMutation
>;
export const createUserGroup = /* GraphQL */ `mutation CreateUserGroup(
  $input: CreateUserGroupInput!
  $condition: ModelUserGroupConditionInput
) {
  createUserGroup(input: $input, condition: $condition) {
    id
    resourceId
    groupType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserGroupMutationVariables,
  APITypes.CreateUserGroupMutation
>;
export const updateUserGroup = /* GraphQL */ `mutation UpdateUserGroup(
  $input: UpdateUserGroupInput!
  $condition: ModelUserGroupConditionInput
) {
  updateUserGroup(input: $input, condition: $condition) {
    id
    resourceId
    groupType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserGroupMutationVariables,
  APITypes.UpdateUserGroupMutation
>;
export const deleteUserGroup = /* GraphQL */ `mutation DeleteUserGroup(
  $input: DeleteUserGroupInput!
  $condition: ModelUserGroupConditionInput
) {
  deleteUserGroup(input: $input, condition: $condition) {
    id
    resourceId
    groupType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserGroupMutationVariables,
  APITypes.DeleteUserGroupMutation
>;
export const createUserGroupMember = /* GraphQL */ `mutation CreateUserGroupMember(
  $input: CreateUserGroupMemberInput!
  $condition: ModelUserGroupMemberConditionInput
) {
  createUserGroupMember(input: $input, condition: $condition) {
    id
    resourceId
    resourceAndUserId
    userId
    userGroupId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserGroupMemberMutationVariables,
  APITypes.CreateUserGroupMemberMutation
>;
export const updateUserGroupMember = /* GraphQL */ `mutation UpdateUserGroupMember(
  $input: UpdateUserGroupMemberInput!
  $condition: ModelUserGroupMemberConditionInput
) {
  updateUserGroupMember(input: $input, condition: $condition) {
    id
    resourceId
    resourceAndUserId
    userId
    userGroupId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserGroupMemberMutationVariables,
  APITypes.UpdateUserGroupMemberMutation
>;
export const deleteUserGroupMember = /* GraphQL */ `mutation DeleteUserGroupMember(
  $input: DeleteUserGroupMemberInput!
  $condition: ModelUserGroupMemberConditionInput
) {
  deleteUserGroupMember(input: $input, condition: $condition) {
    id
    resourceId
    resourceAndUserId
    userId
    userGroupId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserGroupMemberMutationVariables,
  APITypes.DeleteUserGroupMemberMutation
>;
export const createUserOrganizationAssociation = /* GraphQL */ `mutation CreateUserOrganizationAssociation(
  $input: CreateUserOrganizationAssociationInput!
  $condition: ModelUserOrganizationAssociationConditionInput
) {
  createUserOrganizationAssociation(input: $input, condition: $condition) {
    id
    userId
    organizationId
    associationType
    permissions
    role
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserOrganizationAssociationMutationVariables,
  APITypes.CreateUserOrganizationAssociationMutation
>;
export const updateUserOrganizationAssociation = /* GraphQL */ `mutation UpdateUserOrganizationAssociation(
  $input: UpdateUserOrganizationAssociationInput!
  $condition: ModelUserOrganizationAssociationConditionInput
) {
  updateUserOrganizationAssociation(input: $input, condition: $condition) {
    id
    userId
    organizationId
    associationType
    permissions
    role
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserOrganizationAssociationMutationVariables,
  APITypes.UpdateUserOrganizationAssociationMutation
>;
export const deleteUserOrganizationAssociation = /* GraphQL */ `mutation DeleteUserOrganizationAssociation(
  $input: DeleteUserOrganizationAssociationInput!
  $condition: ModelUserOrganizationAssociationConditionInput
) {
  deleteUserOrganizationAssociation(input: $input, condition: $condition) {
    id
    userId
    organizationId
    associationType
    permissions
    role
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserOrganizationAssociationMutationVariables,
  APITypes.DeleteUserOrganizationAssociationMutation
>;
export const createWorkSpecification = /* GraphQL */ `mutation CreateWorkSpecification(
  $input: CreateWorkSpecificationInput!
  $condition: ModelWorkSpecificationConditionInput
) {
  createWorkSpecification(input: $input, condition: $condition) {
    id
    dimensionId
    issueId
    propertyId
    createdInSolution
    body
    description
    workTypeId
    itemNumber
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    version
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkSpecificationMutationVariables,
  APITypes.CreateWorkSpecificationMutation
>;
export const updateWorkSpecification = /* GraphQL */ `mutation UpdateWorkSpecification(
  $input: UpdateWorkSpecificationInput!
  $condition: ModelWorkSpecificationConditionInput
) {
  updateWorkSpecification(input: $input, condition: $condition) {
    id
    dimensionId
    issueId
    propertyId
    createdInSolution
    body
    description
    workTypeId
    itemNumber
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    version
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkSpecificationMutationVariables,
  APITypes.UpdateWorkSpecificationMutation
>;
export const deleteWorkSpecification = /* GraphQL */ `mutation DeleteWorkSpecification(
  $input: DeleteWorkSpecificationInput!
  $condition: ModelWorkSpecificationConditionInput
) {
  deleteWorkSpecification(input: $input, condition: $condition) {
    id
    dimensionId
    issueId
    propertyId
    createdInSolution
    body
    description
    workTypeId
    itemNumber
    measurement {
      length
      width
      dimensionType
      measurementUnit
      __typename
    }
    version
    localLastUpdatedTime
    opaqueSyncReconciliationToken
    canView
    canEdit
    canDelete
    createdBy
    canViewList
    canViewEntityVersionMap
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkSpecificationMutationVariables,
  APITypes.DeleteWorkSpecificationMutation
>;
export const createWorkType = /* GraphQL */ `mutation CreateWorkType(
  $input: CreateWorkTypeInput!
  $condition: ModelWorkTypeConditionInput
) {
  createWorkType(input: $input, condition: $condition) {
    id
    name
    shortDescription
    longDescription
    groupName
    unitPrice
    unitCost
    dimensionType
    measurementUnit
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkTypeMutationVariables,
  APITypes.CreateWorkTypeMutation
>;
export const updateWorkType = /* GraphQL */ `mutation UpdateWorkType(
  $input: UpdateWorkTypeInput!
  $condition: ModelWorkTypeConditionInput
) {
  updateWorkType(input: $input, condition: $condition) {
    id
    name
    shortDescription
    longDescription
    groupName
    unitPrice
    unitCost
    dimensionType
    measurementUnit
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkTypeMutationVariables,
  APITypes.UpdateWorkTypeMutation
>;
export const deleteWorkType = /* GraphQL */ `mutation DeleteWorkType(
  $input: DeleteWorkTypeInput!
  $condition: ModelWorkTypeConditionInput
) {
  deleteWorkType(input: $input, condition: $condition) {
    id
    name
    shortDescription
    longDescription
    groupName
    unitPrice
    unitCost
    dimensionType
    measurementUnit
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkTypeMutationVariables,
  APITypes.DeleteWorkTypeMutation
>;
export const createWorkTypeGroup = /* GraphQL */ `mutation CreateWorkTypeGroup(
  $input: CreateWorkTypeGroupInput!
  $condition: ModelWorkTypeGroupConditionInput
) {
  createWorkTypeGroup(input: $input, condition: $condition) {
    id
    latestWorkTypeVersion
    environmentAgnosticWorkTypeGroupId
    isDiscoverable
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkTypeGroupMutationVariables,
  APITypes.CreateWorkTypeGroupMutation
>;
export const updateWorkTypeGroup = /* GraphQL */ `mutation UpdateWorkTypeGroup(
  $input: UpdateWorkTypeGroupInput!
  $condition: ModelWorkTypeGroupConditionInput
) {
  updateWorkTypeGroup(input: $input, condition: $condition) {
    id
    latestWorkTypeVersion
    environmentAgnosticWorkTypeGroupId
    isDiscoverable
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkTypeGroupMutationVariables,
  APITypes.UpdateWorkTypeGroupMutation
>;
export const deleteWorkTypeGroup = /* GraphQL */ `mutation DeleteWorkTypeGroup(
  $input: DeleteWorkTypeGroupInput!
  $condition: ModelWorkTypeGroupConditionInput
) {
  deleteWorkTypeGroup(input: $input, condition: $condition) {
    id
    latestWorkTypeVersion
    environmentAgnosticWorkTypeGroupId
    isDiscoverable
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkTypeGroupMutationVariables,
  APITypes.DeleteWorkTypeGroupMutation
>;
export const createWorkTypePricing = /* GraphQL */ `mutation CreateWorkTypePricing(
  $input: CreateWorkTypePricingInput!
  $condition: ModelWorkTypePricingConditionInput
) {
  createWorkTypePricing(input: $input, condition: $condition) {
    id
    entityId
    workTypeGroupId
    body
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateWorkTypePricingMutationVariables,
  APITypes.CreateWorkTypePricingMutation
>;
export const updateWorkTypePricing = /* GraphQL */ `mutation UpdateWorkTypePricing(
  $input: UpdateWorkTypePricingInput!
  $condition: ModelWorkTypePricingConditionInput
) {
  updateWorkTypePricing(input: $input, condition: $condition) {
    id
    entityId
    workTypeGroupId
    body
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateWorkTypePricingMutationVariables,
  APITypes.UpdateWorkTypePricingMutation
>;
export const deleteWorkTypePricing = /* GraphQL */ `mutation DeleteWorkTypePricing(
  $input: DeleteWorkTypePricingInput!
  $condition: ModelWorkTypePricingConditionInput
) {
  deleteWorkTypePricing(input: $input, condition: $condition) {
    id
    entityId
    workTypeGroupId
    body
    canView
    canEdit
    canDelete
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteWorkTypePricingMutationVariables,
  APITypes.DeleteWorkTypePricingMutation
>;
export const createDefaultWorkTypePricing = /* GraphQL */ `mutation CreateDefaultWorkTypePricing(
  $input: CreateDefaultWorkTypePricingInput!
  $condition: ModelDefaultWorkTypePricingConditionInput
) {
  createDefaultWorkTypePricing(input: $input, condition: $condition) {
    id
    unitCost
    unitPrice
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDefaultWorkTypePricingMutationVariables,
  APITypes.CreateDefaultWorkTypePricingMutation
>;
export const updateDefaultWorkTypePricing = /* GraphQL */ `mutation UpdateDefaultWorkTypePricing(
  $input: UpdateDefaultWorkTypePricingInput!
  $condition: ModelDefaultWorkTypePricingConditionInput
) {
  updateDefaultWorkTypePricing(input: $input, condition: $condition) {
    id
    unitCost
    unitPrice
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDefaultWorkTypePricingMutationVariables,
  APITypes.UpdateDefaultWorkTypePricingMutation
>;
export const deleteDefaultWorkTypePricing = /* GraphQL */ `mutation DeleteDefaultWorkTypePricing(
  $input: DeleteDefaultWorkTypePricingInput!
  $condition: ModelDefaultWorkTypePricingConditionInput
) {
  deleteDefaultWorkTypePricing(input: $input, condition: $condition) {
    id
    unitCost
    unitPrice
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDefaultWorkTypePricingMutationVariables,
  APITypes.DeleteDefaultWorkTypePricingMutation
>;
export const createTemporaryWorkType = /* GraphQL */ `mutation CreateTemporaryWorkType(
  $input: CreateTemporaryWorkTypeInput!
  $condition: ModelTemporaryWorkTypeConditionInput
) {
  createTemporaryWorkType(input: $input, condition: $condition) {
    id
    workTypeGroupId
    environmentAgnosticWorkTypeGroupId
    body
    version
    schemaVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemporaryWorkTypeMutationVariables,
  APITypes.CreateTemporaryWorkTypeMutation
>;
export const updateTemporaryWorkType = /* GraphQL */ `mutation UpdateTemporaryWorkType(
  $input: UpdateTemporaryWorkTypeInput!
  $condition: ModelTemporaryWorkTypeConditionInput
) {
  updateTemporaryWorkType(input: $input, condition: $condition) {
    id
    workTypeGroupId
    environmentAgnosticWorkTypeGroupId
    body
    version
    schemaVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemporaryWorkTypeMutationVariables,
  APITypes.UpdateTemporaryWorkTypeMutation
>;
export const deleteTemporaryWorkType = /* GraphQL */ `mutation DeleteTemporaryWorkType(
  $input: DeleteTemporaryWorkTypeInput!
  $condition: ModelTemporaryWorkTypeConditionInput
) {
  deleteTemporaryWorkType(input: $input, condition: $condition) {
    id
    workTypeGroupId
    environmentAgnosticWorkTypeGroupId
    body
    version
    schemaVersion
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemporaryWorkTypeMutationVariables,
  APITypes.DeleteTemporaryWorkTypeMutation
>;
export const createTender = /* GraphQL */ `mutation CreateTender(
  $input: CreateTenderInput!
  $condition: ModelTenderConditionInput
) {
  createTender(input: $input, condition: $condition) {
    id
    solutionId
    status
    latestVersion
    awardedVersion
    projectNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenderMutationVariables,
  APITypes.CreateTenderMutation
>;
export const updateTender = /* GraphQL */ `mutation UpdateTender(
  $input: UpdateTenderInput!
  $condition: ModelTenderConditionInput
) {
  updateTender(input: $input, condition: $condition) {
    id
    solutionId
    status
    latestVersion
    awardedVersion
    projectNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenderMutationVariables,
  APITypes.UpdateTenderMutation
>;
export const deleteTender = /* GraphQL */ `mutation DeleteTender(
  $input: DeleteTenderInput!
  $condition: ModelTenderConditionInput
) {
  deleteTender(input: $input, condition: $condition) {
    id
    solutionId
    status
    latestVersion
    awardedVersion
    projectNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenderMutationVariables,
  APITypes.DeleteTenderMutation
>;
export const createTenderMinorVersion = /* GraphQL */ `mutation CreateTenderMinorVersion(
  $input: CreateTenderMinorVersionInput!
  $condition: ModelTenderMinorVersionConditionInput
) {
  createTenderMinorVersion(input: $input, condition: $condition) {
    id
    tenderId
    version
    solutionId
    solutionMinorVersion
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      __typename
    }
    contentKey
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTenderMinorVersionMutationVariables,
  APITypes.CreateTenderMinorVersionMutation
>;
export const updateTenderMinorVersion = /* GraphQL */ `mutation UpdateTenderMinorVersion(
  $input: UpdateTenderMinorVersionInput!
  $condition: ModelTenderMinorVersionConditionInput
) {
  updateTenderMinorVersion(input: $input, condition: $condition) {
    id
    tenderId
    version
    solutionId
    solutionMinorVersion
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      __typename
    }
    contentKey
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTenderMinorVersionMutationVariables,
  APITypes.UpdateTenderMinorVersionMutation
>;
export const deleteTenderMinorVersion = /* GraphQL */ `mutation DeleteTenderMinorVersion(
  $input: DeleteTenderMinorVersionInput!
  $condition: ModelTenderMinorVersionConditionInput
) {
  deleteTenderMinorVersion(input: $input, condition: $condition) {
    id
    tenderId
    version
    solutionId
    solutionMinorVersion
    metadata {
      name
      propertyContactName
      propertyAddress
      propertyType
      solutionDueDate
      consultantName
      consultantPhoneNumber
      consultantEmail
      __typename
    }
    contentKey
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTenderMinorVersionMutationVariables,
  APITypes.DeleteTenderMinorVersionMutation
>;
export const createTag = /* GraphQL */ `mutation CreateTag(
  $input: CreateTagInput!
  $condition: ModelTagConditionInput
) {
  createTag(input: $input, condition: $condition) {
    id
    name
    createdBy
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTagMutationVariables,
  APITypes.CreateTagMutation
>;
export const updateTag = /* GraphQL */ `mutation UpdateTag(
  $input: UpdateTagInput!
  $condition: ModelTagConditionInput
) {
  updateTag(input: $input, condition: $condition) {
    id
    name
    createdBy
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTagMutationVariables,
  APITypes.UpdateTagMutation
>;
export const deleteTag = /* GraphQL */ `mutation DeleteTag(
  $input: DeleteTagInput!
  $condition: ModelTagConditionInput
) {
  deleteTag(input: $input, condition: $condition) {
    id
    name
    createdBy
    propertyId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTagMutationVariables,
  APITypes.DeleteTagMutation
>;
export const createUserOnboardingProgress = /* GraphQL */ `mutation CreateUserOnboardingProgress(
  $input: CreateUserOnboardingProgressInput!
  $condition: ModelUserOnboardingProgressConditionInput
) {
  createUserOnboardingProgress(input: $input, condition: $condition) {
    id
    userId
    hasUserBeenAssociatedWithOrganization
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserOnboardingProgressMutationVariables,
  APITypes.CreateUserOnboardingProgressMutation
>;
export const updateUserOnboardingProgress = /* GraphQL */ `mutation UpdateUserOnboardingProgress(
  $input: UpdateUserOnboardingProgressInput!
  $condition: ModelUserOnboardingProgressConditionInput
) {
  updateUserOnboardingProgress(input: $input, condition: $condition) {
    id
    userId
    hasUserBeenAssociatedWithOrganization
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserOnboardingProgressMutationVariables,
  APITypes.UpdateUserOnboardingProgressMutation
>;
export const deleteUserOnboardingProgress = /* GraphQL */ `mutation DeleteUserOnboardingProgress(
  $input: DeleteUserOnboardingProgressInput!
  $condition: ModelUserOnboardingProgressConditionInput
) {
  deleteUserOnboardingProgress(input: $input, condition: $condition) {
    id
    userId
    hasUserBeenAssociatedWithOrganization
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserOnboardingProgressMutationVariables,
  APITypes.DeleteUserOnboardingProgressMutation
>;
export const createTemplate = /* GraphQL */ `mutation CreateTemplate(
  $input: CreateTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  createTemplate(input: $input, condition: $condition) {
    id
    type
    name
    s3Key
    ownerId
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemplateMutationVariables,
  APITypes.CreateTemplateMutation
>;
export const updateTemplate = /* GraphQL */ `mutation UpdateTemplate(
  $input: UpdateTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  updateTemplate(input: $input, condition: $condition) {
    id
    type
    name
    s3Key
    ownerId
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemplateMutationVariables,
  APITypes.UpdateTemplateMutation
>;
export const deleteTemplate = /* GraphQL */ `mutation DeleteTemplate(
  $input: DeleteTemplateInput!
  $condition: ModelTemplateConditionInput
) {
  deleteTemplate(input: $input, condition: $condition) {
    id
    type
    name
    s3Key
    ownerId
    ownerType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemplateMutationVariables,
  APITypes.DeleteTemplateMutation
>;
export const createTemporaryAuthorizationCode = /* GraphQL */ `mutation CreateTemporaryAuthorizationCode(
  $input: CreateTemporaryAuthorizationCodeInput!
  $condition: ModelTemporaryAuthorizationCodeConditionInput
) {
  createTemporaryAuthorizationCode(input: $input, condition: $condition) {
    id
    code
    userId
    expiresAt
    createdAt
    ttl
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTemporaryAuthorizationCodeMutationVariables,
  APITypes.CreateTemporaryAuthorizationCodeMutation
>;
export const updateTemporaryAuthorizationCode = /* GraphQL */ `mutation UpdateTemporaryAuthorizationCode(
  $input: UpdateTemporaryAuthorizationCodeInput!
  $condition: ModelTemporaryAuthorizationCodeConditionInput
) {
  updateTemporaryAuthorizationCode(input: $input, condition: $condition) {
    id
    code
    userId
    expiresAt
    createdAt
    ttl
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTemporaryAuthorizationCodeMutationVariables,
  APITypes.UpdateTemporaryAuthorizationCodeMutation
>;
export const deleteTemporaryAuthorizationCode = /* GraphQL */ `mutation DeleteTemporaryAuthorizationCode(
  $input: DeleteTemporaryAuthorizationCodeInput!
  $condition: ModelTemporaryAuthorizationCodeConditionInput
) {
  deleteTemporaryAuthorizationCode(input: $input, condition: $condition) {
    id
    code
    userId
    expiresAt
    createdAt
    ttl
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTemporaryAuthorizationCodeMutationVariables,
  APITypes.DeleteTemporaryAuthorizationCodeMutation
>;
export const createLinkRegistry = /* GraphQL */ `mutation CreateLinkRegistry(
  $input: CreateLinkRegistryInput!
  $condition: ModelLinkRegistryConditionInput
) {
  createLinkRegistry(input: $input, condition: $condition) {
    id
    propertyId
    action
    variables
    published
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLinkRegistryMutationVariables,
  APITypes.CreateLinkRegistryMutation
>;
export const updateLinkRegistry = /* GraphQL */ `mutation UpdateLinkRegistry(
  $input: UpdateLinkRegistryInput!
  $condition: ModelLinkRegistryConditionInput
) {
  updateLinkRegistry(input: $input, condition: $condition) {
    id
    propertyId
    action
    variables
    published
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateLinkRegistryMutationVariables,
  APITypes.UpdateLinkRegistryMutation
>;
export const deleteLinkRegistry = /* GraphQL */ `mutation DeleteLinkRegistry(
  $input: DeleteLinkRegistryInput!
  $condition: ModelLinkRegistryConditionInput
) {
  deleteLinkRegistry(input: $input, condition: $condition) {
    id
    propertyId
    action
    variables
    published
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteLinkRegistryMutationVariables,
  APITypes.DeleteLinkRegistryMutation
>;
export const createExternalReportBranding = /* GraphQL */ `mutation CreateExternalReportBranding(
  $input: CreateExternalReportBrandingInput!
  $condition: ModelExternalReportBrandingConditionInput
) {
  createExternalReportBranding(input: $input, condition: $condition) {
    id
    name
    logoKey
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExternalReportBrandingMutationVariables,
  APITypes.CreateExternalReportBrandingMutation
>;
export const updateExternalReportBranding = /* GraphQL */ `mutation UpdateExternalReportBranding(
  $input: UpdateExternalReportBrandingInput!
  $condition: ModelExternalReportBrandingConditionInput
) {
  updateExternalReportBranding(input: $input, condition: $condition) {
    id
    name
    logoKey
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExternalReportBrandingMutationVariables,
  APITypes.UpdateExternalReportBrandingMutation
>;
export const deleteExternalReportBranding = /* GraphQL */ `mutation DeleteExternalReportBranding(
  $input: DeleteExternalReportBrandingInput!
  $condition: ModelExternalReportBrandingConditionInput
) {
  deleteExternalReportBranding(input: $input, condition: $condition) {
    id
    name
    logoKey
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExternalReportBrandingMutationVariables,
  APITypes.DeleteExternalReportBrandingMutation
>;
export const createMeeting = /* GraphQL */ `mutation CreateMeeting(
  $input: CreateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  createMeeting(input: $input, condition: $condition) {
    id
    status
    data
    createdBy
    mediaPipelineId
    recordingKey
    recordingAttachmentId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMeetingMutationVariables,
  APITypes.CreateMeetingMutation
>;
export const updateMeeting = /* GraphQL */ `mutation UpdateMeeting(
  $input: UpdateMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  updateMeeting(input: $input, condition: $condition) {
    id
    status
    data
    createdBy
    mediaPipelineId
    recordingKey
    recordingAttachmentId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMeetingMutationVariables,
  APITypes.UpdateMeetingMutation
>;
export const deleteMeeting = /* GraphQL */ `mutation DeleteMeeting(
  $input: DeleteMeetingInput!
  $condition: ModelMeetingConditionInput
) {
  deleteMeeting(input: $input, condition: $condition) {
    id
    status
    data
    createdBy
    mediaPipelineId
    recordingKey
    recordingAttachmentId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMeetingMutationVariables,
  APITypes.DeleteMeetingMutation
>;
export const createAttendee = /* GraphQL */ `mutation CreateAttendee(
  $input: CreateAttendeeInput!
  $condition: ModelAttendeeConditionInput
) {
  createAttendee(input: $input, condition: $condition) {
    id
    meetingId
    entityId
    name
    role
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAttendeeMutationVariables,
  APITypes.CreateAttendeeMutation
>;
export const updateAttendee = /* GraphQL */ `mutation UpdateAttendee(
  $input: UpdateAttendeeInput!
  $condition: ModelAttendeeConditionInput
) {
  updateAttendee(input: $input, condition: $condition) {
    id
    meetingId
    entityId
    name
    role
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAttendeeMutationVariables,
  APITypes.UpdateAttendeeMutation
>;
export const deleteAttendee = /* GraphQL */ `mutation DeleteAttendee(
  $input: DeleteAttendeeInput!
  $condition: ModelAttendeeConditionInput
) {
  deleteAttendee(input: $input, condition: $condition) {
    id
    meetingId
    entityId
    name
    role
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAttendeeMutationVariables,
  APITypes.DeleteAttendeeMutation
>;
export const createCodeBuildJob = /* GraphQL */ `mutation CreateCodeBuildJob(
  $input: CreateCodeBuildJobInput!
  $condition: ModelCodeBuildJobConditionInput
) {
  createCodeBuildJob(input: $input, condition: $condition) {
    id
    parentId
    projectName
    status
    artifactPath
    buildStartTime
    buildEndTime
    requestedBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCodeBuildJobMutationVariables,
  APITypes.CreateCodeBuildJobMutation
>;
export const updateCodeBuildJob = /* GraphQL */ `mutation UpdateCodeBuildJob(
  $input: UpdateCodeBuildJobInput!
  $condition: ModelCodeBuildJobConditionInput
) {
  updateCodeBuildJob(input: $input, condition: $condition) {
    id
    parentId
    projectName
    status
    artifactPath
    buildStartTime
    buildEndTime
    requestedBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCodeBuildJobMutationVariables,
  APITypes.UpdateCodeBuildJobMutation
>;
export const deleteCodeBuildJob = /* GraphQL */ `mutation DeleteCodeBuildJob(
  $input: DeleteCodeBuildJobInput!
  $condition: ModelCodeBuildJobConditionInput
) {
  deleteCodeBuildJob(input: $input, condition: $condition) {
    id
    parentId
    projectName
    status
    artifactPath
    buildStartTime
    buildEndTime
    requestedBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCodeBuildJobMutationVariables,
  APITypes.DeleteCodeBuildJobMutation
>;
export const createResourceNotificationSetting = /* GraphQL */ `mutation CreateResourceNotificationSetting(
  $input: CreateResourceNotificationSettingInput!
  $condition: ModelResourceNotificationSettingConditionInput
) {
  createResourceNotificationSetting(input: $input, condition: $condition) {
    resourceId
    resourceType
    notificationType
    recipients {
      recipientId
      recipientIdType
      notificationChannels
      enabled
      __typename
    }
    enabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResourceNotificationSettingMutationVariables,
  APITypes.CreateResourceNotificationSettingMutation
>;
export const updateResourceNotificationSetting = /* GraphQL */ `mutation UpdateResourceNotificationSetting(
  $input: UpdateResourceNotificationSettingInput!
  $condition: ModelResourceNotificationSettingConditionInput
) {
  updateResourceNotificationSetting(input: $input, condition: $condition) {
    resourceId
    resourceType
    notificationType
    recipients {
      recipientId
      recipientIdType
      notificationChannels
      enabled
      __typename
    }
    enabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateResourceNotificationSettingMutationVariables,
  APITypes.UpdateResourceNotificationSettingMutation
>;
export const deleteResourceNotificationSetting = /* GraphQL */ `mutation DeleteResourceNotificationSetting(
  $input: DeleteResourceNotificationSettingInput!
  $condition: ModelResourceNotificationSettingConditionInput
) {
  deleteResourceNotificationSetting(input: $input, condition: $condition) {
    resourceId
    resourceType
    notificationType
    recipients {
      recipientId
      recipientIdType
      notificationChannels
      enabled
      __typename
    }
    enabled
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteResourceNotificationSettingMutationVariables,
  APITypes.DeleteResourceNotificationSettingMutation
>;
export const createAssessmentSchedule = /* GraphQL */ `mutation CreateAssessmentSchedule(
  $input: CreateAssessmentScheduleInput!
  $condition: ModelAssessmentScheduleConditionInput
) {
  createAssessmentSchedule(input: $input, condition: $condition) {
    id
    propertyId
    name
    description
    startDate
    endDate
    recurrence {
      type
      dailyRecurrence {
        interval
        __typename
      }
      weeklyRecurrence {
        interval
        daysOfWeek
        __typename
      }
      monthlyRecurrence {
        type
        interval
        dayOfMonth
        nthWeekDay {
          weekNumber
          day
          __typename
        }
        __typename
      }
      __typename
    }
    authorizedIdentifiers
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentScheduleMutationVariables,
  APITypes.CreateAssessmentScheduleMutation
>;
export const updateAssessmentSchedule = /* GraphQL */ `mutation UpdateAssessmentSchedule(
  $input: UpdateAssessmentScheduleInput!
  $condition: ModelAssessmentScheduleConditionInput
) {
  updateAssessmentSchedule(input: $input, condition: $condition) {
    id
    propertyId
    name
    description
    startDate
    endDate
    recurrence {
      type
      dailyRecurrence {
        interval
        __typename
      }
      weeklyRecurrence {
        interval
        daysOfWeek
        __typename
      }
      monthlyRecurrence {
        type
        interval
        dayOfMonth
        nthWeekDay {
          weekNumber
          day
          __typename
        }
        __typename
      }
      __typename
    }
    authorizedIdentifiers
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentScheduleMutationVariables,
  APITypes.UpdateAssessmentScheduleMutation
>;
export const deleteAssessmentSchedule = /* GraphQL */ `mutation DeleteAssessmentSchedule(
  $input: DeleteAssessmentScheduleInput!
  $condition: ModelAssessmentScheduleConditionInput
) {
  deleteAssessmentSchedule(input: $input, condition: $condition) {
    id
    propertyId
    name
    description
    startDate
    endDate
    recurrence {
      type
      dailyRecurrence {
        interval
        __typename
      }
      weeklyRecurrence {
        interval
        daysOfWeek
        __typename
      }
      monthlyRecurrence {
        type
        interval
        dayOfMonth
        nthWeekDay {
          weekNumber
          day
          __typename
        }
        __typename
      }
      __typename
    }
    authorizedIdentifiers
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentScheduleMutationVariables,
  APITypes.DeleteAssessmentScheduleMutation
>;
export const createResourceAssessmentScheduleAssociation = /* GraphQL */ `mutation CreateResourceAssessmentScheduleAssociation(
  $input: CreateResourceAssessmentScheduleAssociationInput!
  $condition: ModelResourceAssessmentScheduleAssociationConditionInput
) {
  createResourceAssessmentScheduleAssociation(
    input: $input
    condition: $condition
  ) {
    id
    assessmentScheduleId
    resourceId
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateResourceAssessmentScheduleAssociationMutationVariables,
  APITypes.CreateResourceAssessmentScheduleAssociationMutation
>;
export const updateResourceAssessmentScheduleAssociation = /* GraphQL */ `mutation UpdateResourceAssessmentScheduleAssociation(
  $input: UpdateResourceAssessmentScheduleAssociationInput!
  $condition: ModelResourceAssessmentScheduleAssociationConditionInput
) {
  updateResourceAssessmentScheduleAssociation(
    input: $input
    condition: $condition
  ) {
    id
    assessmentScheduleId
    resourceId
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateResourceAssessmentScheduleAssociationMutationVariables,
  APITypes.UpdateResourceAssessmentScheduleAssociationMutation
>;
export const deleteResourceAssessmentScheduleAssociation = /* GraphQL */ `mutation DeleteResourceAssessmentScheduleAssociation(
  $input: DeleteResourceAssessmentScheduleAssociationInput!
  $condition: ModelResourceAssessmentScheduleAssociationConditionInput
) {
  deleteResourceAssessmentScheduleAssociation(
    input: $input
    condition: $condition
  ) {
    id
    assessmentScheduleId
    resourceId
    resourceType
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteResourceAssessmentScheduleAssociationMutationVariables,
  APITypes.DeleteResourceAssessmentScheduleAssociationMutation
>;
export const createAssessment = /* GraphQL */ `mutation CreateAssessment(
  $input: CreateAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  createAssessment(input: $input, condition: $condition) {
    id
    scheduleId
    resourceId
    propertyId
    resourceType
    createdBy
    submittedBy {
      firstName
      lastName
      __typename
    }
    createdTime
    status
    issueIds
    tagIds
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAssessmentMutationVariables,
  APITypes.CreateAssessmentMutation
>;
export const updateAssessment = /* GraphQL */ `mutation UpdateAssessment(
  $input: UpdateAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  updateAssessment(input: $input, condition: $condition) {
    id
    scheduleId
    resourceId
    propertyId
    resourceType
    createdBy
    submittedBy {
      firstName
      lastName
      __typename
    }
    createdTime
    status
    issueIds
    tagIds
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAssessmentMutationVariables,
  APITypes.UpdateAssessmentMutation
>;
export const deleteAssessment = /* GraphQL */ `mutation DeleteAssessment(
  $input: DeleteAssessmentInput!
  $condition: ModelAssessmentConditionInput
) {
  deleteAssessment(input: $input, condition: $condition) {
    id
    scheduleId
    resourceId
    propertyId
    resourceType
    createdBy
    submittedBy {
      firstName
      lastName
      __typename
    }
    createdTime
    status
    issueIds
    tagIds
    description
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAssessmentMutationVariables,
  APITypes.DeleteAssessmentMutation
>;
export const createContact = /* GraphQL */ `mutation CreateContact(
  $input: CreateContactInput!
  $condition: ModelContactConditionInput
) {
  createContact(input: $input, condition: $condition) {
    id
    name
    email
    phoneNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateContactMutationVariables,
  APITypes.CreateContactMutation
>;
export const updateContact = /* GraphQL */ `mutation UpdateContact(
  $input: UpdateContactInput!
  $condition: ModelContactConditionInput
) {
  updateContact(input: $input, condition: $condition) {
    id
    name
    email
    phoneNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateContactMutationVariables,
  APITypes.UpdateContactMutation
>;
export const deleteContact = /* GraphQL */ `mutation DeleteContact(
  $input: DeleteContactInput!
  $condition: ModelContactConditionInput
) {
  deleteContact(input: $input, condition: $condition) {
    id
    name
    email
    phoneNumber
    createdBy
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteContactMutationVariables,
  APITypes.DeleteContactMutation
>;
export const createProperty3PIntegrationConfiguration = /* GraphQL */ `mutation CreateProperty3PIntegrationConfiguration(
  $input: CreateProperty3PIntegrationConfigurationInput!
  $condition: ModelProperty3PIntegrationConfigurationConditionInput
) {
  createProperty3PIntegrationConfiguration(
    input: $input
    condition: $condition
  ) {
    id
    propertyId
    workflowEndpoint
    workflowName
    clientId
    clientSecret
    tokenUrl
    authorizeUrl
    scope
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProperty3PIntegrationConfigurationMutationVariables,
  APITypes.CreateProperty3PIntegrationConfigurationMutation
>;
export const updateProperty3PIntegrationConfiguration = /* GraphQL */ `mutation UpdateProperty3PIntegrationConfiguration(
  $input: UpdateProperty3PIntegrationConfigurationInput!
  $condition: ModelProperty3PIntegrationConfigurationConditionInput
) {
  updateProperty3PIntegrationConfiguration(
    input: $input
    condition: $condition
  ) {
    id
    propertyId
    workflowEndpoint
    workflowName
    clientId
    clientSecret
    tokenUrl
    authorizeUrl
    scope
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProperty3PIntegrationConfigurationMutationVariables,
  APITypes.UpdateProperty3PIntegrationConfigurationMutation
>;
export const deleteProperty3PIntegrationConfiguration = /* GraphQL */ `mutation DeleteProperty3PIntegrationConfiguration(
  $input: DeleteProperty3PIntegrationConfigurationInput!
  $condition: ModelProperty3PIntegrationConfigurationConditionInput
) {
  deleteProperty3PIntegrationConfiguration(
    input: $input
    condition: $condition
  ) {
    id
    propertyId
    workflowEndpoint
    workflowName
    clientId
    clientSecret
    tokenUrl
    authorizeUrl
    scope
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProperty3PIntegrationConfigurationMutationVariables,
  APITypes.DeleteProperty3PIntegrationConfigurationMutation
>;
export const createConversationState = /* GraphQL */ `mutation CreateConversationState(
  $input: CreateConversationStateInput!
  $condition: ModelConversationStateConditionInput
) {
  createConversationState(input: $input, condition: $condition) {
    id
    attachments
    conversationType
    extractedDetails
    conversationStatus
    invokerId
    nextStep
    nextStepMessage
    userId
    externalConversationId
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateConversationStateMutationVariables,
  APITypes.CreateConversationStateMutation
>;
export const updateConversationState = /* GraphQL */ `mutation UpdateConversationState(
  $input: UpdateConversationStateInput!
  $condition: ModelConversationStateConditionInput
) {
  updateConversationState(input: $input, condition: $condition) {
    id
    attachments
    conversationType
    extractedDetails
    conversationStatus
    invokerId
    nextStep
    nextStepMessage
    userId
    externalConversationId
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateConversationStateMutationVariables,
  APITypes.UpdateConversationStateMutation
>;
export const deleteConversationState = /* GraphQL */ `mutation DeleteConversationState(
  $input: DeleteConversationStateInput!
  $condition: ModelConversationStateConditionInput
) {
  deleteConversationState(input: $input, condition: $condition) {
    id
    attachments
    conversationType
    extractedDetails
    conversationStatus
    invokerId
    nextStep
    nextStepMessage
    userId
    externalConversationId
    phoneNumber
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteConversationStateMutationVariables,
  APITypes.DeleteConversationStateMutation
>;
export const createPolicyTemplateLink = /* GraphQL */ `mutation CreatePolicyTemplateLink(
  $input: CreatePolicyTemplateLinkInput!
  $condition: ModelPolicyTemplateLinkConditionInput
) {
  createPolicyTemplateLink(input: $input, condition: $condition) {
    id
    templateId
    entityId
    entityType
    resourceId
    resourceType
    grantedBy
    grantedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePolicyTemplateLinkMutationVariables,
  APITypes.CreatePolicyTemplateLinkMutation
>;
export const updatePolicyTemplateLink = /* GraphQL */ `mutation UpdatePolicyTemplateLink(
  $input: UpdatePolicyTemplateLinkInput!
  $condition: ModelPolicyTemplateLinkConditionInput
) {
  updatePolicyTemplateLink(input: $input, condition: $condition) {
    id
    templateId
    entityId
    entityType
    resourceId
    resourceType
    grantedBy
    grantedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePolicyTemplateLinkMutationVariables,
  APITypes.UpdatePolicyTemplateLinkMutation
>;
export const deletePolicyTemplateLink = /* GraphQL */ `mutation DeletePolicyTemplateLink(
  $input: DeletePolicyTemplateLinkInput!
  $condition: ModelPolicyTemplateLinkConditionInput
) {
  deletePolicyTemplateLink(input: $input, condition: $condition) {
    id
    templateId
    entityId
    entityType
    resourceId
    resourceType
    grantedBy
    grantedAt
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePolicyTemplateLinkMutationVariables,
  APITypes.DeletePolicyTemplateLinkMutation
>;
export const createStaticDashboardData = /* GraphQL */ `mutation CreateStaticDashboardData($input: CreateStaticDashboardDataInput!) {
  createStaticDashboardData(input: $input)
}
` as GeneratedMutation<
  APITypes.CreateStaticDashboardDataMutationVariables,
  APITypes.CreateStaticDashboardDataMutation
>;
export const createBillingProfileSession = /* GraphQL */ `mutation CreateBillingProfileSession(
  $input: CreateBillingProfileSessionInput!
) {
  createBillingProfileSession(input: $input) {
    status
    message
    url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBillingProfileSessionMutationVariables,
  APITypes.CreateBillingProfileSessionMutation
>;
export const createBillingProfile = /* GraphQL */ `mutation CreateBillingProfile($input: CreateBillingProfileInput!) {
  createBillingProfile(input: $input) {
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBillingProfileMutationVariables,
  APITypes.CreateBillingProfileMutation
>;
export const reportMeteringUsage = /* GraphQL */ `mutation ReportMeteringUsage($input: ReportMeteringUsageRequest!) {
  reportMeteringUsage(input: $input) {
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ReportMeteringUsageMutationVariables,
  APITypes.ReportMeteringUsageMutation
>;
export const updateSubscriptionTier = /* GraphQL */ `mutation UpdateSubscriptionTier($input: UpdateSubscriptionTierInput!) {
  updateSubscriptionTier(input: $input) {
    status
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionTierMutationVariables,
  APITypes.UpdateSubscriptionTierMutation
>;
export const sendCompleteEvent = /* GraphQL */ `mutation SendCompleteEvent(
  $executionId: ID!
  $status: CompleteEventStatus!
  $result: String
) {
  sendCompleteEvent(
    executionId: $executionId
    status: $status
    result: $result
  ) {
    executionId
    status
    result
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendCompleteEventMutationVariables,
  APITypes.SendCompleteEventMutation
>;
export const handleExternalReportSubmission = /* GraphQL */ `mutation HandleExternalReportSubmission($input: ExternalReportSubmission!) {
  handleExternalReportSubmission(input: $input)
}
` as GeneratedMutation<
  APITypes.HandleExternalReportSubmissionMutationVariables,
  APITypes.HandleExternalReportSubmissionMutation
>;
export const generateReport = /* GraphQL */ `mutation GenerateReport($executionId: ID!, $input: GenerateReportRequest!) {
  generateReport(executionId: $executionId, input: $input) {
    executionId
    status
    result
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GenerateReportMutationVariables,
  APITypes.GenerateReportMutation
>;
export const sendNotificationToUsers = /* GraphQL */ `mutation SendNotificationToUsers($input: sendNotificationToUsersInput!) {
  sendNotificationToUsers(input: $input)
}
` as GeneratedMutation<
  APITypes.SendNotificationToUsersMutationVariables,
  APITypes.SendNotificationToUsersMutation
>;
export const joinChimeMeetingPublic = /* GraphQL */ `mutation JoinChimeMeetingPublic(
  $meetingId: String!
  $name: String!
  $role: AttendeeRole!
) {
  joinChimeMeetingPublic(meetingId: $meetingId, name: $name, role: $role)
}
` as GeneratedMutation<
  APITypes.JoinChimeMeetingPublicMutationVariables,
  APITypes.JoinChimeMeetingPublicMutation
>;
export const shareMeetingLink = /* GraphQL */ `mutation ShareMeetingLink($input: ShareMeetingLinkInput!) {
  shareMeetingLink(input: $input)
}
` as GeneratedMutation<
  APITypes.ShareMeetingLinkMutationVariables,
  APITypes.ShareMeetingLinkMutation
>;
export const triggerBuildStaticSite = /* GraphQL */ `mutation TriggerBuildStaticSite($propertyId: String!) {
  triggerBuildStaticSite(propertyId: $propertyId)
}
` as GeneratedMutation<
  APITypes.TriggerBuildStaticSiteMutationVariables,
  APITypes.TriggerBuildStaticSiteMutation
>;
export const submitQuickQuote = /* GraphQL */ `mutation SubmitQuickQuote($input: [SubmitQuickQuoteInput], $executionId: ID) {
  submitQuickQuote(input: $input, executionId: $executionId) {
    status
    solutionId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitQuickQuoteMutationVariables,
  APITypes.SubmitQuickQuoteMutation
>;
export const submitQuickQuoteWithExistingData = /* GraphQL */ `mutation SubmitQuickQuoteWithExistingData(
  $input: SubmitQuickQuoteExistingDataInput
  $executionId: ID
) {
  submitQuickQuoteWithExistingData(input: $input, executionId: $executionId) {
    status
    solutionId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitQuickQuoteWithExistingDataMutationVariables,
  APITypes.SubmitQuickQuoteWithExistingDataMutation
>;
export const manageConversationState = /* GraphQL */ `mutation ManageConversationState($input: ConversationStateInput!) {
  manageConversationState(input: $input) {
    id
    attachments
    conversationType
    extractedDetails
    nextStep
    nextStepMessage
    externalConversationId
    phoneNumber
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ManageConversationStateMutationVariables,
  APITypes.ManageConversationStateMutation
>;
export const changeRole = /* GraphQL */ `mutation ChangeRole($input: ChangeRoleInput!) {
  changeRole(input: $input)
}
` as GeneratedMutation<
  APITypes.ChangeRoleMutationVariables,
  APITypes.ChangeRoleMutation
>;
export const removeMemberFromOrganization = /* GraphQL */ `mutation RemoveMemberFromOrganization(
  $input: RemoveMemberFromOrganizationInput!
) {
  removeMemberFromOrganization(input: $input)
}
` as GeneratedMutation<
  APITypes.RemoveMemberFromOrganizationMutationVariables,
  APITypes.RemoveMemberFromOrganizationMutation
>;
export const inviteUserToOrganization = /* GraphQL */ `mutation InviteUserToOrganization($input: InviteUserToOrganizationInput!) {
  inviteUserToOrganization(input: $input)
}
` as GeneratedMutation<
  APITypes.InviteUserToOrganizationMutationVariables,
  APITypes.InviteUserToOrganizationMutation
>;
export const acceptInvitationToOrganization = /* GraphQL */ `mutation AcceptInvitationToOrganization($input: AcceptInvitationInput!) {
  acceptInvitationToOrganization(input: $input)
}
` as GeneratedMutation<
  APITypes.AcceptInvitationToOrganizationMutationVariables,
  APITypes.AcceptInvitationToOrganizationMutation
>;
export const updateSubscriptionQuantity = /* GraphQL */ `mutation UpdateSubscriptionQuantity($input: UpdateSubscriptionQuantityInput!) {
  updateSubscriptionQuantity(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionQuantityMutationVariables,
  APITypes.UpdateSubscriptionQuantityMutation
>;
